import { HIDE_QUEST, UPDATE_QUEST } from "@/context/QuestProvider/actions";
import type { QuestActionType } from "@/context/QuestProvider/reducer";
import type { QuestState } from "@ui-kit/QuestList";

// update quest and if quest is complete but not hidden, hide it
export const updateQuestWithAutoHide = async (
  dispatchAction: (action: QuestActionType) => void,
  quest: QuestState,
): Promise<void> => {
  dispatchAction({
    type: UPDATE_QUEST,
    payload: {
      id: quest.ruleId,
      quest,
    },
  });

  if (quest.completed === true && quest.hidden === false) {
    dispatchAction({
      type: HIDE_QUEST,
      payload: {
        id: quest.ruleId,
      },
    });
  }
};
